<template>
  <!-- سایدبار -->
  <el-aside
    class="sidebar"
    :class="{ mobile: isMobile, open: sidebarVisible }"
    :style="isMobile ? {} : { width: '240px' }"
  >
    <img src="/logo5.png" class="logo" />

    <div>
      <h5>مدیریت سیستم</h5>
      <hr />
      <el-menu
        background-color="#205685"
        text-color="#fff"
        active-text-color="#42f5b6"
        class="el-menu-vertical-demo"
        :default-active="getActiveMenu"
        :default-openeds="openSubMenus"
        router
      >
     <!--  <el-menu-item
          index="/area"
          @click="$router.push('/area'), closeSideBar()"
        >
          <img src="/photo/report.svg" />وضعیت کلی
        </el-menu-item>-->
        <!-- زیرمنوی مدیریت چاه‌ها -->
        <el-sub-menu index="managment" class="custom-sub-menu">
          <template #title>
            <div class="submenu-title">
              <el-icon class="icon-left">
                <img src="/photo/manage_well.svg" />
              </el-icon>
              <span>مدیریت چاه‌ها</span>
            </div>
          </template>

          <!-- حلقه روی مناطق -->
          <el-sub-menu
            v-for="group in deviceStore.groupedDevices"
            :key="group.area_id"
            :index="'area-' + group.area_id"
            class="sub-menu-area"
          >
            <template #title>
              <div
                class="submenu-title"
                @click="selectArea(group.area_id, group.name)"
              >
                <span
                  :class="{
                    active: deviceStore.activeArea?.id === group.area_id,
                  }"
                  >{{ group.name }}</span
                >
              </div>
            </template>

            <!-- حلقه روی چاه‌های هر منطقه -->
            <el-menu-item
              v-for="well in group.items"
              :key="well.data.id"
              :index="'well-' + String(well.data.id)"
              :class="{ active: deviceStore.activeDevice?.id === well.data.id }"
              @click="selectWell(group.area_id, well.data)"
            >
              {{ well.data.name }}
            </el-menu-item>
          </el-sub-menu>
        </el-sub-menu>

        <el-menu-item
          index="/report"
          @click="$router.push('/report'), closeSideBar()"
        >
          <img src="/photo/report.svg" />گزارش‌ها
        </el-menu-item>
        <el-menu-item @click="showNotif">
          <img src="/photo/alert.svg" /> هشدارها
        </el-menu-item>
      </el-menu>
    </div>

    <div class="sidebar-footer">
      <h5>پنل کاربری</h5>
      <hr />
      <div style="padding-right: 12px">
        <el-button type="text">
          <img src="/photo/user_icon.svg" /> {{ authStore.user?.name }}
        </el-button>
        <el-button type="text">
          <img src="/photo/location_icon.svg" width="22px" />
          {{ authStore.user?.region_name + " " + authStore.user?.area_name }}
        </el-button>
        <el-button type="text" @click="logout">
          <img src="/photo/logout.svg" />خروج
        </el-button>
      </div>
    </div>
  </el-aside>

  <!-- پس‌زمینه تار موبایل -->
  <div
    v-if="isMobile && sidebarVisible"
    class="sidebar-backdrop"
    @click="sidebarVisible = false"
  ></div>
</template>

<script setup>
import {
  ref,
  onMounted,
  onUnmounted,
  defineExpose,
  watch,
  nextTick,
  computed,
} from "vue";
import { useDeviceStore } from "@/stores/device";
import { useAuthStore } from "@/stores/auth";
import { showToast } from "@/utils/toastHelper";
import { useRoute, useRouter } from "vue-router";
import { async } from "regenerator-runtime";
const route = useRoute();
const router = useRouter();
const openSubMenus = ref([]);
const activeWellIndex = ref(null);
const activeAreaIndex = ref(null);

const deviceStore = useDeviceStore();
const authStore = useAuthStore();

const sidebarVisible = ref(false);
const isMobile = ref(false);

const checkMobile = () => {
  isMobile.value = window.innerWidth <= 768;
  if (!isMobile.value) {
    sidebarVisible.value = true;
  } else {
    sidebarVisible.value = false;
  }
};

onMounted(async() => {
  checkMobile();
  window.addEventListener("resize", checkMobile);

  if (deviceStore.devices.length === 0) {
    await deviceStore.loadUserDevices();
  }

  
});

// انتخاب چاه
function selectWell(areaId, well) {
  deviceStore.setActiveDevice(well);
  activeWellIndex.value = "well-" + well.id;
  openSubMenus.value = ["managment", "area-" + areaId];

  router.push({ path: "/dashboard", query: { well: well.id } });
  closeSideBar();
}
function selectArea(areaId, name) {
  deviceStore.setActiveArea(areaId, name);
  activeAreaIndex.value = "area-" + areaId; // 👈 اضافه شد
  activeWellIndex.value = null; // 👈 چون چاهی انتخاب نشده
  openSubMenus.value = ["managment", "area-" + areaId];
  deviceStore.setActiveDevice(null);
  router.push({ path: "/area", query: { area: areaId } });
  closeSideBar();
}

watch(
  () => deviceStore.groupedDevices,
 async (groups) => {
  
    if (!groups.length) return;

    // بررسی query
    const wellId = route.query.well;
    const areaId = route.query.area;
if(route.path === "/dashboard"){
    if (wellId ) {
      activateWellById(wellId);
    } else if (deviceStore.activeDevice) {
      const active = deviceStore.activeDevice;
      const matchArea = groups.find((area) =>
        area.items.some((w) => w.data.id === active.id)
      );
      if (matchArea) {
        activeWellIndex.value = "well-" + active.id;
        openSubMenus.value = ["managment", "area-" + matchArea.area_id];

        // فقط اگر مسیر فعلی dashboard هست تغییر بده
        if (route.path === "/dashboard") {
          router.replace({ path: "/dashboard", query: { well: active.id } });
        }
      }
    }
}else{
    if (areaId) {
      activateAreaById(areaId);
    } else if (deviceStore.activeArea) {
      const active = deviceStore.activeArea;
      const matchArea = groups.find((area) =>
        area.items.some((w) => w.area_id === active.id)
      );
     
      if (matchArea) {
        activeAreaIndex.value = "area-" + active.id;
        await nextTick();
        
        openSubMenus.value = ["managment", "area-" + matchArea.area_id];
        // فقط اگر مسیر فعلی dashboard هست تغییر بده
        if (route.path === "/area") {
          router.replace({ path: "/area", query: { area: active.id } });
        }
      }
    }
}
  },
  { immediate: true }
);

// اگر query تغییر کرد (مثلاً با back/forward مرورگر)
watch(
  () => route.query.well,
  (wellId) => {
    activateWellById(wellId);
  }
);
watch(
  () => route.query.area,
  (areaId) => {
    if (areaId) {
      activateAreaById(areaId);
      openSubMenus.value = ["managment", "area-" + areaId]; // 👈 اضافه کن
    }
  }
);
function activateWellById(wellId) {
  if (wellId) {
    const matchArea = deviceStore.groupedDevices.find((area) =>
      area.items.some((w) => String(w.data.id) === String(wellId))
    );
    if (matchArea) {
      const matchWell = matchArea.items.find(
        (w) => String(w.data.id) === String(wellId)
      );
      if (matchWell) {
        deviceStore.setActiveDevice(matchWell.data);
        activeWellIndex.value = "well-" + matchWell.data.id;
        openSubMenus.value = ["managment", "area-" + matchArea.area_id];
      }
    }
  } else {
    activeWellIndex.value = null;
    openSubMenus.value = [];
  }
}
function  activateAreaById(areaId) {
  if (areaId) {
    const matchArea = deviceStore.groupedDevices.find(
      (area) => String(area.area_id) === String(areaId)
    );
    if (matchArea) {
      deviceStore.setActiveArea(matchArea.area_id, matchArea.name);
      activeAreaIndex.value = "area-" + matchArea.area_id;
      activeWellIndex.value = null;

      // 👇 اینجا منوی مدیریت چاه‌ها را هم باز می‌کنیم
      openSubMenus.value = ["managment", "area-" + matchArea.area_id];
    }
  } else {
    activeAreaIndex.value = null;
    activeWellIndex.value = null;
    openSubMenus.value = [];
  }
}

const getActiveMenu = computed(() => {
  if (route.path === "/report") return "/report"; // هایلایت گزارش
  if (activeWellIndex.value) return activeWellIndex.value; // هایلایت چاه مدیریت
  if (activeAreaIndex.value) return activeAreaIndex.value; // 👈 اضافه شد

  return null;
});

onUnmounted(() => {
  window.removeEventListener("resize", checkMobile);
});

const toggleSidebar = () => {
  sidebarVisible.value = !sidebarVisible.value;
};
function showNotif() {
  showToast("این قسمت به زودی فعال خواهد شد.از صبر شما سپاس گزاریم", "success");
}
function closeSideBar() {
  if (isMobile.value) toggleSidebar();
}
defineExpose({
  toggleSidebar,
});

const logout = () => {
  deviceStore.reset();
  window.location.href = "/login";
};
</script>

<style scoped>
.sidebar {
  background-color: #205685;
  color: white;
  display: flex;
  flex-direction: column;
  overflow: auto;
  transition: all 0.3s ease;
  z-index: 1001;
}

/* نسخه موبایل - پنهان پیش‌فرض */
.sidebar.mobile {
  position: fixed;
  top: 0;
  bottom: 0;
  right: -100%;
  width: 250px;
  height: 100%;
  transition: right 0.3s ease;
}

/* هنگام باز شدن در موبایل */
.sidebar.mobile.open {
  right: 0;
}

/* پس‌زمینه تیره پشت سایدبار در موبایل */
.sidebar-backdrop {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 1000;
}

/* آیکن‌ها و متن */
.logo {
  padding: 1rem 0;
  width: 80%;
  margin: 10px auto;
}

.sidebar img {
  padding: 10px;
  vertical-align: middle;
}
.sidebar h5 {
  margin-bottom: 5px;
}
.sidebar-footer {
  color: white;
}
.sidebar-footer button {
  display: block;
  margin: 10px;
  color: white;
}
hr {
  width: 90%;
  text-align: right;
}

/* زیرمنو */
.custom-sub-menu .el-sub-menu__title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 48px;
  padding: 0 16px;
}
.submenu-title {
  display: flex;
  align-items: center;
  gap: 8px;
}
.sub-menu-area {
  width: 80%;
}
::v-deep(.sub-menu-area .el-menu.el-menu--inline) {
  padding-right: 15px !important;
}
.icon-left {
  margin-left: 8px;
}

/* چرخش فلش زیرمنو */
::v-deep(.el-sub-menu__icon-arrow) {
  left: 20px !important;
  right: unset !important;
  transform: rotate(90deg) !important;
  transition: transform 0.3s ease !important;
}
::v-deep(
    .el-sub-menu.is-opened > .el-sub-menu__title .el-sub-menu__icon-arrow
  ) {
  transform: rotate(0deg) !important;
}

/* حذف فاصله اضافی */
::v-deep(.el-menu:not(.el-menu--collapse) .el-sub-menu__title) {
  padding-right: unset !important;
}
::v-deep(.el-menu-item) {
  padding: unset !important;
}
.active {
  color: #42f5b6;
}
</style>
